import React from 'react';
import logoImage from '../../assets/images/papaya_profile_pic_logo.png';
import styles from './shared-link-headline.module.css';

class SharedLinkHeadline extends React.Component {
  render() {
    const { presentationName } = this.props;

    return (
      <div className={styles.logoContainer}>
        <img className={styles.logoImg} src={logoImage} alt={'iBooklet 2.0'} />
        <span className={styles.presentationName}>{presentationName}</span>
      </div>
    );
  }
}

export default SharedLinkHeadline;



// WEBPACK FOOTER //
// ./src/components/shared-link-headline/shared-link-headline.js